import React  from 'react';

import peijiansuopei641 from '../assets/img/peijiansuopei641.png';
import peijiansuopei642 from '../assets/img/peijiansuopei642.png';
import peijiansuopei643 from '../assets/img/peijiansuopei643.png';
import tuihuodan641 from '../assets/img/tuihuodan641.png';
import tuihuodan642 from '../assets/img/tuihuodan642.png';

const Enclosure64 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3>一、专用条款内部管控流程</h3>
            <h4>1. 计划部：</h4>
            <p>1.1 基于计划部（集采）完成对市场二级配套、三级配套厂家信息收集，按照月度制定工作量，可检视；</p>
            <p>1.2 定向采购（和供方有年度正规采购合同的），对于供方的开发应召开配件管理公司采购专项会议讨论是否纳入供方体系。</p>
            <p>1.3 非定向采购（无固定的采购合同的），应形成正式的书面报告上报需求部门总监签字、管理公司总经理签字后方可采购。</p>
            <p>1.4 计划部对采购到货的配件差异负监管责任，并负责与供方协调直到问题解决。</p>
            <p>1.5 品牌中心库针对加急调拨到货要快速实现出库，体现“加急时效”；仓储物流部按照正常入库流程完成入库；</p>
            <p>1.6 整合管理公司各部室计划人员，成立计划工作群，对各部室日常采购工作标准的执行情况进行监督。</p>
            <p>1.7 通过展销会收集、内部原有采购渠道收集、市场走访、行业信息建立完善配件公司采购体系：现有资源潍柴、陕汽、法士特、重汽、欧曼、现有资源80%外协件原厂配套采购渠道，完成50%常用件二级供应商采购渠道开发；客车（宇通、苏龙、金旅、中通、亚星等）供应商完成60%原厂配套商渠道开发，完成50%常用件二级供应商渠道开发；海外订单完成农机、装载机、挖掘机、推土机、发电机机组等专用设备橡胶类、液压类、工具类、易损件及专用件采购渠道建立，保证年末海外订单满足率不低于70%；国内采购订单满足率年底不低于80%；截至2019年末采购部成为集团公司配套商采购性价比最具竞争力部门；</p>
            <p>1.8 截至2019年末建立可执行、可落地的采购流程、招标方案；根据客户、市场需求，市场调研主动收集、招标，完成集团公司有效可执行的采购流程 ；建立初始供应商数据库（包含图文）不断更新每周以周报添加附件发送到管理公司；截至2019年末该数据库能够满足集团公司海内外配件需求订单70%满足率；</p>
            <p>未按规定执行对应负责人考核100分。</p>
            <br/>
            <h4>2. 销售配件索赔</h4>
            <br/>
            <img src={peijiansuopei641} alt="" style={{
                width  : '90%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={peijiansuopei642} alt="" style={{
                width  : '90%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={peijiansuopei643} alt="" style={{
                width  : '90%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <p>关于销售配件根据中心库渠道索赔政策、集采配套商务政策，要求及时解决销售过程中配件索赔，48小时完成鉴定、5个工作日解决，未解决的上报管理公司；
未按规定执行对应负责人考核100分。</p>

            <br/>
            <h4>3. 质量检验：</h4>
            <h4>3.1 效率提升</h4>
            <p>通过货位、货区、库存结构调整，完成月度效率核算（备货需要标准起始时间），通过效率核算仓储物流部产能，为增加人员提供数据支持；相关数据上报管理公司统计部；周期：月度，负责人：仓储事业部对应责任人 </p>
            <h4>3.2 货位完整率</h4>
            <p>精准货位是提高效率、新人能够快速进入状态依据，维护货位数据是区域备货员能力体现，出现错误频繁调整为效率提升、库存差异造成障碍，统计部每周两天抽查货位准确性，对于抽查内容进行优化；准确率不低于已定货位90%；责任人：仓储物流事业部对应责任人</p>
            <h4>3.3 库区优化</h4>
            <p>先进先出，针对备货区域、储存区位置及备货时走动距离进行货位调整，出库频次高、出库量大的应更靠近备货区方便取、入，根据历史数据留有足够空间；滞销产品远离备货区紧凑管理；每周提报货位优化明细，上报管理公司；周期：月度，负责人：仓储事业部对应责任人</p>
            <h4>3.4 出库频次、库龄</h4>
            <p>为更好优化库区，将缓动产品优化货位并将优化明细上报管理公司；周期：月度，负责人：仓储事业部对应责任人。</p>
            <h4>3.5 责任人</h4>
            <p>仓储物流部每周五上报检验结果到管理公司，根据出错配件逐项分析出错原因24小时内完成优化，在货位或卡片标注“易出错”，责任人：仓储事业部对应责任人
未按规定执行对应负责人考核100分</p>
            <br/>
            <h4>4. 物资安全</h4>
            <h4>4.1 到货差异</h4>
            <p>4.1.1 仓储物流事业部对厂家到货进行检验核对工作，并形成差异报告并报给中心库，不完整货物不得进入仓储库房。周期：每批入库计划，负责人：仓储事业部对应责任人</p>
            <p>4.1.2 计划科集中入库并将异议件销售到 “中心库采购异议”，由中心库采购完成追溯；3个工作日内上报总监处理结果并在差异报告签字留档；周期：每批入库计划，负责人：中心库对应责任人</p>
            <p>4.1.3 仓储物流事业部出具完整检验标准，现场整理标准，保证检验准确度；仓储区域管理员为一级检验，出库检验为二级检验，复检出现差异者</p>
            <p>未按规定执行对应负责人考核100分。</p>
            <h4>4.2 滞销件明细（库龄）</h4>
            <p>中心库以半年为周期上报积压配件明细，根据明细中心库、管理公司寻求解决办法，降低库存积压；</p>
            <h4>4.3 装卸车损坏，包装不当损坏</h4>
            <p>4.3.1 由个人操作不当造成的配件损坏，按照采购价的50%开具销售单出库。</p>
            <h4>4.4 退库流程</h4>
            <p>4.4.1 已销售到客户的配件退库</p>
            <h4>4.4.1.1 目的：</h4>
            <p>配件公司所有工作基于实现销售、保证物资安全，针对以销售尽量不要产生订单，针对客户退库认真分析退库原因不断提高客户满意度及客户需求；杜绝现在电话沟通退库不能及时跟进无人监管现状；</p>
            <h4>4.4.1.2 范围：</h4>
            <p>通过正常流程销售到客户的配件产生退库的（不包含索赔件、意外损坏件）按照此流程执行；</p>
            <h4>4.4.1.3 退库单生成：</h4>
            <p>1、品牌中心库根据客户退单诉求详细了解退单原因，自己生成或客户生成退库明细综合考虑必须请示品牌总监是否可以退库，批量退库需上报管理公司（根据明细可以通过视频照片初步判断退库配件状态）；</p>
            <p>2、了解客户发送时间、承运单位（快递、物流配送、沿途配送捎回、业务捎回等）、物流单号（方便仓储收货对应）、此时告知客户收货人为仓储人员（仓储指定同仓储退库对接人为一个人）；同时告知客户包装内付与中心库已核对的清单</p>
            <p>3、品牌中心库生成配件公司《到达客户后配件退库单》并登记相关信息：退库编号（年度第几张）、品牌中心库名称、退库对接人（事业部指定基本不变）、仓储对接人（事业部指定基本不变）、客户单位（全称同步怀远）、预计发送时间、预计到达时间、物流方式、退件明细（原销售单号、名称、件号、预退数量）、退库原因；</p>
            <p>4、品牌中心库将《到达客户配件退库单》以电子版形式发送到“配件公司索赔、损坏、退库群”并保证仓储“退库对接人”收到；原则：该退库单应早于实物到达仓储“退库对接人”手中；</p>
            <h4>4.4.1.4 收到实物检验与确定</h4>
            <p>1、仓储物流部及“对库对接人”打印《到达客户配件退库单》（三联），根据《到达客户后配件退库单》信息及时跟进仓储退库到货，并按照入库流程核实退库明细中件号、实物、数量，原则不影响销售；有问题的（预退数量与实收数量不符的、严重损坏的）第一时间以影像方式反馈到中心库“退库对接人”第一时间反馈到客户；</p>
            <p>2、仓储物流部及“退库对接人”根据客户退库实物如实填写《到达客户后配件退库单》并登记相关信息：实收数量、合格数量（不影响销售的视为合格）、备注（检验结果简单阐述清楚）、检验签字确认、仓储负责人签字确认（总监、副总监、科长）；第一时间将《到达客户配件退库单》以电子版形式发送到“配件公司索赔、损坏、退库群”并保证品牌中心库“退库对接人”收到；</p>
            <p>3、仓储物流部对客户到货物资有管理责任，原则：24小时完成检验，批量退库酌情延长；</p>
            <h4>4.4.1.5 退库销售单生成</h4>
            <p>1、中心库及“退库对接人”根据仓储检验结果有异议的第一时间对接客户沟通确定最终退库结果并开具销售单（退库单）；无意义可直接开具销售单（退单）并通知仓储物流部打印；</p>
            <p>2、仓储物流部打印销售单（退单）按照入库流程实现凭单入库，纸质怀远销售单同《到达客户配件退库单》（三联）按照销售单流传路径当天将反馈到中心库及“退库对接人”处；</p>
            <p>3、针对退库争议配件请示品牌总监处理，特殊情况上报配件公司；</p>
            <p><strong>该流程规定自通知公布即开始实时，操作过程中不合适可以优化，对不履行规定部门将月度考核事业部第一责权人100分/每单；</strong></p>
            <br/>
            <img src={tuihuodan641} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={tuihuodan642} alt="" style={{

                width  : '80%',
                display: 'block',
                margin : '0 auto',
            }}/>
            <br/>
            <h4>4.4.2 依据退库原因优化流程及标准，完善仓储管理，当天反馈到管理公司；</h4>
            <h4>4.5 关于备货时效、准确度每月完成一次竞技比赛，包含标准执行、单项备货时效、检验质量；前三名依次奖励500分、300分、200分。</h4>
            <p>未按规定执行对应负责人考核100分。</p>
            <br/>
            <h4>5. 新员工入职</h4>
            <p>不分岗位必须完成在仓储物流部见习2个月，熟悉仓储流程、专业知识；无仓储部出具见习报告无法完成转正。</p>
            <br/>
            <h4>6. 培训</h4>
            <p>6.1 非仓储物流人员每月有一天仓储物流部实践，实践收获以书面形式上报事业部总监，统计部备案，（仓储物流部有针对性安排实践并做评价）激励100分。</p>
            <p>6.2 管理公司各部室关于整车结构、总成结构结合云豪学院制定培训计划。</p>
            <p>未按规定执行对应负责人考核100分。</p>
            <br/>
            <h4>7.网络营销</h4>
            <p>7.1独立微信号：产品信息、成交信息、提示信息，销售人员销售过程中鼓励客户添加朋友，通过该微信号将上述信息发布到自己朋友圈（不拉群、不骚扰、只做自己朋友圈宣传）。视添加情况每添加一人激励10分。</p>
            <p>责任部门：配件营销事业部对应责任人</p>
            <p>7.2独立公众号：宣传、配件商城、实现分销功能（区域代理）；</p>
            <p>责任部门：中心库对应责任人</p>

            <br/><br/>
        </div>
    </div>


export default Enclosure64;